import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
    KeyPairingStateResponse,
    OemAuthResponse,
    OemMetadataResponse,
    PairingUrlResponse,
    VehicleConfigStateResponse,
} from '../../app/features/connect/domain/oem.model';
import { OemRepository } from '../../app/features/connect/infrastructure/oem.repository';
import { BaseMockService } from '../../app/infrastructure/services/base-mock.service';
import {
    OEM_AUTH_RESPONSE_MOCK,
    OEM_KEY_PAIRING_STATE_RESPONSE_MOCK,
    OEM_METADATA_RESPONSE_MOCK,
    OEM_PAIRING_URL_RESPONSE_MOCK,
    OEM_VEHICLE_CONFIG_STATE_RESPONSE_MOCK,
} from '../dataMocks/oem-response-mock';

@Injectable({
    providedIn: 'root',
})
export class OemApiMockService extends BaseMockService implements OemRepository {
    constructor() {
        super('oem');
    }

    eligibilityChecks(): Observable<void> {
        return this.handle('eligibilityChecks', of(void 0));
    }

    auth(): Observable<OemAuthResponse> {
        return this.handle('auth', of({ ...OEM_AUTH_RESPONSE_MOCK }));
    }

    metadata(): Observable<OemMetadataResponse> {
        return this.handle('metadata', of({ ...OEM_METADATA_RESPONSE_MOCK }));
    }

    exchangeCode(): Observable<void> {
        return this.handle('exchangeCode', of(void 0));
    }

    keyPairingState(): Observable<KeyPairingStateResponse> {
        return this.handle('keyPairingState', of({ ...OEM_KEY_PAIRING_STATE_RESPONSE_MOCK }));
    }

    pairingUrl(): Observable<PairingUrlResponse> {
        return this.handle('pairingUrl', of({ ...OEM_PAIRING_URL_RESPONSE_MOCK }));
    }

    vehicleConfigState(): Observable<VehicleConfigStateResponse> {
        return this.handle('vehicleConfigState', of({ ...OEM_VEHICLE_CONFIG_STATE_RESPONSE_MOCK }));
    }

    sendVehicleConfig(): Observable<void> {
        return this.handle('sendVehicleConfig', of(void 0));
    }

    smartCarWebhookSubscription(): Observable<void> {
        return this.handle('smartCarWebhookSubscription', of(void 0));
    }
}
